export const Types = {
    GET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: "GET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: "SET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: " GET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: "SET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL: "GET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL: "SET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL: "GET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL: "SET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "GET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "SET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "GET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "SET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL: " GET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL: " SET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL: " PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL: " SET_PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL",
    PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL: "PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL: "SET_PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL",
    GET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL: "GET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL: "SET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL: "SET_PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL",
    PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL: "PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL",
    PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL: "PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL: "SET_PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL: "SET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL",
    PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL: "PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL",
    ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL: "ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL: "SET_ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL",

    GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL",

    GET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL: "GET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL: "SET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL",

    GET_PLANNED_FILES: "GET_PLANNED_FILES",
    SET_PLANNED_FILES: "SET_PLANNED_FILES",

    ADD_PLANNED_FILES: "ADD_PLANNED_FILES",

    MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL: "MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL: "SET_MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL",

    GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: "GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL: "SET_GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL",

    DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL: "DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL",
    SET_DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL: "SET_DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL",

    DELETE_PLANNED_FILES: "DELETE_PLANNED_FILES",

    SHOW_SNACK_MESSAGE_IN_PLANNED_MAINTENANCE_DETAIL: "SHOW_SNACK_MESSAGE_IN_PLANNED_MAINTENANCE_DETAIL",
    RESET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL: "RESET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL",
    RESET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL: "RESET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL",

    GET_EKED_EQUIPMENT_LIST_PLANNED: "GET_EKED_EQUIPMENT_LIST_PLANNED",
    SET_EKED_EQUIPMENT_LIST_PLANNED: "SET_EKED_EQUIPMENT_LIST_PLANNED",
    UPDATE_EKED_EQUIPMENT_LIST_PLANNED: "UPDATE_EKED_EQUIPMENT_LIST_PLANNED",
};

export const deleteTask = (payload) => ({
    type: Types.DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setDeleteTask = (payload) => ({
    type: Types.SET_DELEET_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const getTaskHistoryById = (payload) => ({
    type: Types.GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setTaskHistoryById = (payload) => ({
    type: Types.SET_GET_TRACK_HISTORY_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const MaintenancePauseReason = (payload) => ({
    type: Types.MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setMaintenancePauseReason = (payload) => ({
    type: Types.SET_MAINTENANCE_PAUSE_REASON_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const getPlannedFiles = (payload) => ({
    type: Types.GET_PLANNED_FILES,
    payload,
});
export const setPlannedFiles = (payload) => ({
    type: Types.SET_PLANNED_FILES,
    payload,
});

export const addPlannedFiles = (payload) => ({
    type: Types.ADD_PLANNED_FILES,
    payload,
});

export const BreakdownReasonDetail = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setBreakdownReasonDetail = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const BreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setBreakdownReasonPlaceByGroupId = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const AddTechnician = (payload) => ({
    type: Types.ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setAddTechnician = (payload) => ({
    type: Types.SET_ADD_TECHNICIANS_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const plannedMaintenanceUpdateTask = (payload) => ({
    type: Types.PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setplannedMaintenanceUpdateTask = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setplannedMaintenancePause = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const plannedMaintenancePause = (payload) => ({
    type: Types.PLANNED_MAINTENANCE_PAUSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setPlannedMaintenanceCloaseComplete = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const plannedMaintenanceCloaseComplete = (payload) => ({
    type: Types.PLANNED_MAINTENANCE_CLOSE_COMPLETE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setPlannedMaintenance = (payload) => ({
    type: Types.SET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const getPlannedMaintenance = (payload) => ({
    type: Types.GET_PLANNED_MAINTENANCE_PLAY_START_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setPlannedMaintenancePlayOrClose = (payload) => ({
    type: Types.SET_PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const plannedMaintenancePlayOrClose = (payload) => ({
    type: Types.PLAN_MAINTENANCE_PLAY_CLOSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const plannedMaintenanceAssign = (payload) => ({
    type: Types.PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setPlannedMaintenanceAssign = (payload) => ({
    type: Types.SET_PLAN_MAINTENANCE_ASSIGN_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const getTechnicianListByPoolId = (payload) => ({
    type: Types.GET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setTechnicianListByPoolId = (payload) => ({
    type: Types.SET_TECHNICAL_LIST_BY_POOL_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const getBreakdownEffectList = (payload) => ({
    type: Types.GET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setBreakdownEffectList = (payload) => ({
    type: Types.SET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const getBreakdownReasonGroupList = (payload) => ({
    type: Types.GET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setBreakdownReasonGroupList = (payload) => ({
    type: Types.SET_BREAK_DOWN_REASON_GROUP_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const getPoolList = (payload) => ({
    type: Types.GET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setPoolList = (payload) => ({
    type: Types.SET_POOL_LIST_FOR_MAITENANCE_DETAIL_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const getbreakdownRootCause = (payload) => ({
    type: Types.GET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setbreakdownRootCause = (payload) => ({
    type: Types.SET_BREAK_DOWN_ROOT_CAUSE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const getSameLevelListById = (payload) => ({
    type: Types.GET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const setSameLevelListById = (payload) => ({
    type: Types.SET_SAME_LEVEL_LIST_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});
export const getTaskDetailById = (payload) => ({
    type: Types.GET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const setTaskDetailById = (payload) => ({
    type: Types.SET_TASKS_DETAIL_BY_ID_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE_IN_PLANNED_MAINTENANCE_DETAIL,
    payload,
});

export const resetBreakDownEffectsList = () => ({
    type: Types.RESET_BREAK_DOWN_Effect_LIST_IN_PLANNED_MAINTENANCE_DETAIL,
});

export const resetplannedMaintenanceUpdateTask = () => ({
    type: Types.RESET_PLANNED_MAINTENANCE_UPDATE_TASK_IN_PLANNED_MAINTENANCE_DETAIL,
});

export const deletePlannedFiles = (payload) => ({
    type: Types.DELETE_PLANNED_FILES,
    payload,
});

export const getEkedEquipmentList = (payload) => ({
    type: Types.GET_EKED_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const setEkedEquipmentList = (payload) => ({
    type: Types.SET_EKED_EQUIPMENT_LIST_PLANNED,
    payload,
});

export const updateEkedEquipmentList = (payload) => ({
    type: Types.UPDATE_EKED_EQUIPMENT_LIST_PLANNED,
    payload,
});
